import React from 'react';
import { Modal } from 'junto-ui';

import { BoxWithMargin } from 'components-core';
import { Wrapper, Title, Text, CloseButton, Link, Icon } from './FederalIdModal.styles';

const FederalIdModal = ({ isOpen, closeModal }) => (
  <Modal isOpen={isOpen} mobileFullScreen onBackdropClick={closeModal} closeModal={closeModal}>
    <Wrapper>
      <BoxWithMargin desktop={{ bottom: '32px' }}>
        <Icon />
      </BoxWithMargin>

      <Title>Ops!</Title>

      <BoxWithMargin desktop={{ bottom: '20px' }}>
        <Text>
          Percebemos que o CNPJ digitado é de uma empresa já atendida pela Junto Seguros. Os
          créditos de indicação são exclusivos para novos clientes.
        </Text>
      </BoxWithMargin>

      <BoxWithMargin desktop={{ bottom: '32px' }}>
        <Text>
          Se tiver alguma dúvida, fale com a gente por e-mail:{' '}
          <Link href="mailto:equipe@juntoseguros.com">equipe@juntoseguros.com</Link>
        </Text>
      </BoxWithMargin>

      <CloseButton onClick={closeModal}>Voltar e digitar outro CNPJ</CloseButton>
    </Wrapper>
  </Modal>
);

export default FederalIdModal;
